/**
 * @desc 列表
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<Array<defs.appCenter.AppDomainResponseDto>>;
export function request(
  params: API.appCenter.appDomain.list.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/appDomain/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
